/*
 * Default JS file, this is basically a copy of the old gulpfile approach
 * This is used on any page that doesn't have it's own js file alongside it
 */

require('./shared')

require('../site_scripts/mtc_vue_import')

// core plugins
require('../../../../core/js/plugins/mtc_chosen');
require('../../../../core/js/plugins/mtc_cookies');
require('../../../../core/js/plugins/mtc_datetimepicker');
require('../../../../core/js/plugins/mtc_easing');
require('../../../../core/js/plugins/mtc_featured_vehicles');
require('../../../../core/js/plugins/mtc_fitvids');
require('../../../../core/js/plugins/mtc_functions');
require('../../../../core/js/plugins/mtc_jquery.waypoints');
require('../../../../core/js/plugins/mtc_jquery_fileupload');
require('../../../../core/js/plugins/mtc_match_height');
require('../../../../core/js/plugins/mtc_multicurrency');
require('../../../../core/js/plugins/mtc_number_arrows');
require('../../../../core/js/plugins/mtc_objectfit');
require('../../../../core/js/plugins/mtc_slick');
require('../../../../core/js/plugins/mtc_tabs');
require('../../../../core/js/plugins/mtc_touch_punch');
require('../../../../core/js/plugins/mtc_waypoints');

require('./franchise_shared_functions');

require('../site_scripts/mtc_submit_form');
require('../site_scripts/mtc_enquiry_form_overlay');
require('../site_scripts/mtc_search_links_load_more');
require('../site_scripts/mtc_offers');
require('../site_scripts/mtc_vue_slim_search');
require('../site_scripts/mtc_show_hide_opening_times');
require('../site_scripts/mtc_finance_video_overlay');
require('../site_scripts/mtc_read_more_small_print');
require('../site_scripts/mtc_slide_out_menu');
// require('../site_scripts/mtc_search_lazy_loading');
require('../site_scripts/mtc_finance_tabs');
require('../site_scripts/mtc_search_item_key_features');
require('../site_scripts/mtc_mpg_affordability_calculator');
require('../site_scripts/mtc_collapsible_panels');
require('../site_scripts/mtc_personalised_form');
require('../site_scripts/mtc_alt_read_more');
require('../site_scripts/mtc_wrap_last_word');
require('../site_scripts/mtc_wrap_first_word');
require('../site_scripts/mtc_small_enquiry_form');
require('../site_scripts/mtc_simple_tabs');
require('../site_scripts/mtc_html5_geolocation');
require('../site_scripts/mtc_directions_form');
require('../site_scripts/mtc_stockist_google_map');
require('../site_scripts/mtc_dealership_map_functions');
require('../site_scripts/mtc_opening_times_toggle');
require('../site_scripts/mtc_directions_map');
require('../site_scripts/mtc_print_popup');
require('../site_scripts/mtc_print_directions');
require('../site_scripts/mtc_legacy_desktop_menu');
require('../site_scripts/mtc_legacy_mobile_menu');
require('../site_scripts/mtc_add_this_on_demand');
require('../site_scripts/mtc_share_options');
require('../site_scripts/mtc_spec_tabs');
require('../site_scripts/mtc_grid_scripts');
require('../site_scripts/mtc_featured_items_new');
require('../site_scripts/mtc_mobile_cta_carousel');
require('../site_scripts/mtc_franchise_dealerships_read_more');
require('../site_scripts/mtc_sell_your_vehicle_enquiry_form');
require('../site_scripts/mtc_legacy_carstore_finance_calculator');
require('../site_scripts/mtc_carz_mobile_menu');
require('../site_scripts/mtc_carz_footer_menu_trigger');
require('../site_scripts/mtc_spec_accordion_menu');
require('../site_scripts/mtc_page_tab_links');
require('../site_scripts/mtc_featured_items_carousel');
require('../site_scripts/mtc_franchise_sliders')
require('../site_scripts/mtc_sticky_franchise_header')
require('../site_scripts/mtc_item_card_slider')
require('../site_scripts/mtc_franchise_filter')
require('../site_scripts/mtc_franchise_menu')
require('../site_scripts/mtc_franchise_tabs')
require('../site_scripts/mtc_color_select')
require('../site_scripts/mtc_sticky_franchise_offers')
require('../site_scripts/mtc_news_scroll_to');
require('../site_scripts/mtc_similar_offers_slider')
require('../site_scripts/mtc_select_offer')
require('../pap/flyout-menu')
require('../franchise/flyout-menu')

// readding used car search js globally due to bespoke landing pages
require('../site_scripts/mtc_side_search_filter');
require('../site_scripts/mtc_item_images');
require('../site_scripts/mtc_storefront_popup');
require('../franchise/flyout-menu.js')
require('../global/read-more')
// require('../site_scripts/mtc_search_lazy_loading');

require('../functions');

require('../../../../plugins/BigReveal/js/mtc_reveal');
require('../../../../plugins/Gallery/js/mtc_gallery');
require('../../../../plugins/GoogleMaps/js/mtc_google_maps');
require('../../../../plugins/GridManager/js/mtc_script');
require('../../../../plugins/ImageTagging/js/mtc_image_tags');
require('../../../../plugins/PAFLookup/js/mtc_paflookup');
require('../../../../plugins/Slider/js/mtc_slider');


require('../../../../cms/js/mtc_general_frontend_cms');

require('../../../../modules/FinanceCalculator/js/mtc_finance_calculator');
require('../../../../modules/Offers/js/mtc_script');
require('../../../../modules/Search/js/mtc_search');

require('../site_scripts/mtc_read_more');
require('../site_scripts/mtc_slider_with_tabs');
require('../script');

// site specific styles, e.g. a.css on older setup
require('../../css/mtc_style.less')

